import { useEffect, useState } from "react";
import {
  Svg,
  Circle,
  Pos,
  Lab,
  Outer,
  Text1,
  Text2,
  CircleGroup,
  LabContainer,
} from "./Overview.label.style";

import { useLocation } from "react-router-dom";
import { useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { useClick } from "./Overview.label.click";
import { _project } from "state/store.projects";
import { useBreak } from "hooks/useBreak";
import { _bootstrap } from "state/store.bootstrap";

export const MobileLabel = ({
  c,
  sc,
  d,
  l,
  rmode,
  r,
  labelsInfo,
  mobileLabelAxis,
  hoveredId,
  setShowLabel,
}) => {
  const { pin, pid } = useGet(active_project);

  const unitStatus = useGet(_project)?.unitStatuses?.[pin]?.[pid] ?? [];
  const availableTranslation =
    unitStatus?.find((u) => u.ID === 10)?.Name ?? "";

  const projectUnitsStatus = useGet(_bootstrap)?.projects ?? [];
  const options = useGet(_project)?.filteroptions ?? {};
  const allUnits = useGet(_project)?.units ?? {};

  const PID = labelsInfo?.PID;
  const PIN = labelsInfo?.PIN;

  const totalUnits =
    allUnits?.[pin]?.[pid]?.Units?.reduce(
      (ac, val) =>
        ac + (val?.Data?.ProjectID?.Value === PID ? 1 : 0),
      0
    ) ?? 0;

  const roomSize =
    options?.[PIN]?.[PID]?.find(
      (p) => p?.Label === "Størrelse" || p?.Label === "Size"
    ) ?? "";

  const noOfRooms =
    options?.[PIN]?.[PID]?.find(
      (p) => p?.Label === "Værelser" || p?.Label === "Rooms"
    ) ?? "";

  const hardcodedMoveInDate =
    allUnits?.[PIN]?.[PID]?.Units?.[0]?.Data?.Indflytningsdatoproperty
      ?.UnformattedValue;

  const here = useLocation().pathname.split("/");
  const buttonsLabel =
    useGet(_project)?.buttonsLabel?.[pin]?.[pid] ?? [];

  const isOverview = here[here.length - 1] === "isometry";
  const click = useClick();

  const s = 0.6 / sc === Infinity ? 10 : 0.6 / sc;
  const cx = r?.[0];
  const cy = r?.[1];

  const [notHovered, setNotHovered] = useState(true);
  const dl = { d, l, s, notHovered };

  // ✅ Inactive labels based on text ONLY (not bf03/bf04)
  const isInactive =
    labelsInfo?.Presentation?.toLowerCase()?.includes("kommer senere") ||
    labelsInfo?.Presentation?.toLowerCase()?.includes("coming soon");

  useEffect(() => {
    setNotHovered(hoveredId !== labelsInfo?.URLSafe || isInactive);
  }, [hoveredId, labelsInfo?.URLSafe, isInactive]);

  if (!isOverview || rmode) return null;

  return (
    <Pos
      c={c}
      style={{
        position: "absolute",
        transform: "scale(2)",
        pointerEvents: "auto",
        zIndex: hoveredId === labelsInfo?.URLSafe ? 10 : 5,
      }}
    >
      <Svg viewBox="0 0 100 100">
        <CircleGroup transform={`translate(${cx} ${cy})`}>
          <Circle cx={0} cy={0} r={15} clr={clr} />
          <Circle cx={0} cy={0} r={25} fillOpacity="0.5" clr={clr} />
          <Circle cx={0} cy={0} r={35} fillOpacity="0.3" clr={clr} />
        </CircleGroup>
      </Svg>

      {hoveredId === labelsInfo?.URLSafe && !isInactive ? (
        /* 🔵 Active label */
        <Outer {...dl} xAxis={mobileLabelAxis?.[0]} yAxis={mobileLabelAxis?.[1]}>
          <LabContainer {...dl} clr={clr}>
            <Text2
              style={{
                borderBottom: "2px solid #fff",
                padding: "8px 16px",
              }}
            >
              {
                buttonsLabel?.find(
                  (btn) => btn.UILabelProperty === "SeeAvailableUnits"
                )?.Label
              }
            </Text2>
          </LabContainer>
        </Outer>
      ) : (
        /* ⚪ Default label */
        <Outer {...dl} xAxis={mobileLabelAxis?.[0]} yAxis={mobileLabelAxis?.[1]}>
          <LabContainer
            {...dl}
            clr={clr}
            style={{
              pointerEvents: isInactive ? "none" : "auto",
              opacity: isInactive ? 0.6 : 1,
            }}
          >
            <Text2 style={{ padding: "8px 16px" }}>
              {
                buttonsLabel?.find(
                  (btn) => btn.UILabelProperty === "SeeAvailableUnits"
                )?.Label
              }
            </Text2>
          </LabContainer>
        </Outer>
      )}
    </Pos>
  );
};
